module.exports = __webpack_public_path__ + "img/icon-sb-room-of-choice-icon-160x120-v1.b01c4e7.svg";